import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../../selectors/page';
import { IServiceItem, servicesMapper, trackShowGoToAddFormLink, trackShowServicesContainer } from '../utils';
import { mapPageTypeToAnalytics } from '../../../utils/getPageviewObject';

export const useTrackServicesShow = (services: IServiceItem[]) => {
  const pageType = useSelector(selectPageType);
  const mappedServices = servicesMapper(services);

  return React.useCallback(() => {
    trackShowServicesContainer({
      pageType: mapPageTypeToAnalytics[pageType],
      mappedServices,
    });

    trackShowGoToAddFormLink(mapPageTypeToAnalytics[pageType]);
  }, [pageType, services, mappedServices]);
};
